var map = {
	"./book.svg": "./svg/book.svg",
	"./checkmark.svg": "./svg/checkmark.svg",
	"./confetti-bottom.svg": "./svg/confetti-bottom.svg",
	"./confetti-top.svg": "./svg/confetti-top.svg",
	"./drama.svg": "./svg/drama.svg",
	"./engels.svg": "./svg/engels.svg",
	"./food.svg": "./svg/food.svg",
	"./godsdienst.svg": "./svg/godsdienst.svg",
	"./logo.svg": "./svg/logo.svg",
	"./media.svg": "./svg/media.svg",
	"./nask.svg": "./svg/nask.svg",
	"./sport.svg": "./svg/sport.svg",
	"./techniek.svg": "./svg/techniek.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./svg sync recursive \\.svg$";